const calendarServiceCard = {
  schedule: 'Agendar',
  scheduledDate: 'Data agendada',
  scheduledTo: 'Agendado para',
  scheduled: 'Agendado',
};

export default calendarServiceCard;
